import { Controller } from "@hotwired/stimulus"

// Текст поздравления: свёрнут до нескольких строк, разворачивается по кнопке и
// копируется в буфер одной кнопкой — человек забирает текст, чтобы отправить его
// получателю. Полный текст всегда в DOM (сервер его не режет), сворачивает только
// CSS, поэтому копировать есть что даже в свёрнутом виде.
// JS-first: кнопки лежат в разметке с hidden и включаются здесь — без JS текст
// просто виден целиком, а нерабочих кнопок нет.
export default class extends Controller {
  static targets = ["text", "actions", "toggle", "copy"]
  static values = {
    clamp: { type: Boolean, default: true },
    moreLabel: { type: String, default: "Показать целиком" },
    lessLabel: { type: String, default: "Свернуть" },
    copiedLabel: { type: String, default: "Скопировано" }
  }

  connect() {
    this.copyLabel = this.copyTarget.textContent
    this.actionsTarget.hidden = false
    if (!this.clampValue) return

    this.textTarget.classList.add("pc-greeting-text--clamped")
    // Кнопка раскрытия нужна только если текст реально не влез: короткое
    // поздравление с «Показать целиком» выглядит поломкой.
    requestAnimationFrame(() => this.syncToggle())
  }

  disconnect() {
    clearTimeout(this.restoreTimer)
  }

  syncToggle() {
    const text = this.textTarget
    this.toggleTarget.hidden = text.scrollHeight <= text.clientHeight + 1
  }

  toggle() {
    const clamped = this.textTarget.classList.toggle("pc-greeting-text--clamped")
    this.toggleTarget.textContent = clamped ? this.moreLabelValue : this.lessLabelValue
    this.toggleTarget.setAttribute("aria-expanded", String(!clamped))
  }

  async copy() {
    const text = this.textTarget.textContent.trim()
    if (!text) return

    let copied = false
    try {
      await navigator.clipboard.writeText(text)
      copied = true
    } catch {
      copied = this.copyByExecCommand(text)
    }

    if (copied) this.flashCopied()
  }

  // Clipboard API живёт только в secure context (https/localhost) и требует
  // разрешения — на остальных случаях остаётся старый способ через textarea.
  copyByExecCommand(text) {
    const area = document.createElement("textarea")
    area.value = text
    area.setAttribute("readonly", "")
    area.style.position = "fixed"
    area.style.top = "-1000px"
    document.body.appendChild(area)
    area.select()

    let copied = false
    try {
      copied = document.execCommand("copy")
    } catch {
      copied = false
    }
    area.remove()

    return copied
  }

  flashCopied() {
    clearTimeout(this.restoreTimer)
    this.copyTarget.textContent = this.copiedLabelValue
    this.copyTarget.classList.add("is-copied")
    this.restoreTimer = setTimeout(() => {
      this.copyTarget.textContent = this.copyLabel
      this.copyTarget.classList.remove("is-copied")
    }, 1800)
  }
}
